<span class="mandatory-asterisk">*</span>